import { gql } from "@apollo/client";

const UPDATE_TOURNAMENT = gql`
  mutation updateTournament($id: Float!, $approvalStatus: String) {
    updateTournament(updateTournamentInput: { id: $id, approvalStatus: $approvalStatus }) {
      id
      title
    }
  }
`;

export default UPDATE_TOURNAMENT;
